import { render } from "./healthReport.vue?vue&type=template&id=4cc63b78&scoped=true&ts=true"
import script from "./healthReport.vue?vue&type=script&lang=ts"
export * from "./healthReport.vue?vue&type=script&lang=ts"

import "./healthReport.vue?vue&type=style&index=0&id=4cc63b78&lang=less&scoped=true"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc63b78"]])

export default __exports__